































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import Uploader from '@/components/next/NewUploader.vue';
import { rank, userMessage, checkUserExist } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { Toast, Popup, List } from 'vant';
import qs from 'qs';
Vue.use(Popup).use(List);
@Component({
  components: {
    Uploader,
  },
})
export default class Home extends Vue {
  cityList: any[] = [];
  countyList: any[] = [];
  activity: number = 0;
  tab: any = [{ text: '中秋国庆全市排行' }, { text: '中秋国庆区县排行' }];
  mytn: number | boolean = false;
  myprize: number = 0;
  page1 = 1;
  page2 = 1;
  loading = false;
  finished = false;
  loading1 = false;
  finished1 = false;
  isshow = false;
  isshow1 = false;
  created() {
    this.intoact();
    setTimeout(() => {
      this.isshow = true;
      this.isshow1 = true;
    }, 50);
  }
  onLoad() {
    const unionId = window.localStorage.getItem('unionid');
    if (this.activity === 0) {
      rank(unionId + '', 1, this.page1).then((res: any) => {
        if (this.page1 < 6) {
          this.endListData(res, 1);
        } else {
          this.loading = false;
          this.finished = true;
        }
        if (res.data.personal.rank === false) {
          this.mytn = false;
        } else {
          this.mytn =
            res.data.personal.rank === 0 ? 1 : res.data.personal.rank + 1;
        }
        this.myprize =
          res.data.personal.votes === false ? 0 : res.data.personal.votes;
      });
    } else if (this.activity === 1) {
      rank(unionId + '', 2, this.page2).then((res1: any) => {
        // this.countyList = res1.data.data;
        if (res1.code === 200 && res1.data.data.length > 0) {
          this.endListData(res1, 2);
        } else {
          this.loading1 = false;
          this.finished1 = true;
        }
        if (res1.data.personal.rank === false) {
          this.mytn = false;
        } else {
          this.mytn =
            res1.data.personal.rank === 0 ? 1 : res1.data.personal.rank + 1;
        }
        this.myprize =
          res1.data.personal.votes === false ? 0 : res1.data.personal.votes;
      });
    }
  }
  endListData(res: any, type: number) {
    if (type === 1) {
      this.page1 = this.page1 + 1;
      if (!res.data.data || res.data.data.length === 0) {
        this.finished = true;
      } else {
        this.cityList = [...this.cityList, ...res.data.data];
      }
      this.loading = false;
    } else if (type === 2) {
      this.page2 = this.page2 + 1;
      if (!res.data.data || res.data.data.length === 0) {
        this.finished1 = true;
      } else {
        this.countyList = [...this.countyList, ...res.data.data];
      }
      this.loading1 = false;
    }
  }
  showhistory() {
    this.$router.push('allmytrun');
  }
  changeActivity(index: any) {
    this.isshow = false;
    this.isshow1 = false;
    setTimeout(() => {
      this.isshow = true;
      this.isshow1 = true;
    }, 50);
    if (this.activity === index) {
      return false;
    }
    this.activity = index;
    this.page1 = 1;
    this.page2 = 1;
    this.countyList = [];
    this.cityList = [];
    this.loading = false;
    this.loading1 = false;
    this.finished1 = false;
    this.finished = false;
  }
  intoDetail(id: any) {
    this.$router.push('turndetail?id=' + id);
    // const unionId = window.localStorage.getItem('unionid');
    // userMessage(unionId + '').then((res: any) => {
    // if (res.code === 200) {
    //   this.$router.push('turndetail?id=' + res.data);
    // } else {
    //   Toast(res.msg);
    //   return false;
    // }
    // });
  }
  intoDetailCity(cityName: any) {
    this.$router.push('citytrunnow?cityName=' + cityName);
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  intoact() {
    const unionId = window.localStorage.getItem('unionid');
    console.log(unionId);
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      this.$router.push('home');
    } else if (!unionId && isWeiXin()) {
      this.WechatLogin();
      return false;
    } else {
      checkUserExist(unionId + '').then((res: any) => {
        console.log(res.data);
        if (!res.data) {
          this.$router.push('citysort');
        }
      });
    }
  }
}
